import { render, staticRenderFns } from "./trans-coach-course.vue?vue&type=template&id=f13a9ef8&scoped=true&"
import script from "./trans-coach-course.vue?vue&type=script&lang=js&"
export * from "./trans-coach-course.vue?vue&type=script&lang=js&"
import style0 from "./trans-coach-course.vue?vue&type=style&index=0&id=f13a9ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13a9ef8",
  null
  
)

export default component.exports